<top-banner variant="title" [title]="worker?.name"></top-banner>

<div class="main-content">
  <div class="card animated fadeIn">
    <div class="row">
      <div class="col-md-2 cardtabs-wrapper">
        <app-card-tabs [tabitems]="tabitems" [backLink]="backLink ? { path: backLink, title: 'Back' } : null"></app-card-tabs>
      </div>
      <div class="col-md-10">
        <div class="card-body">
          <card-section-header title="Worker" icon="fa-regular fa-file-alt" [showButton]="false"></card-section-header>

          <div class="alert alert-danger" *ngIf="worker?.deleted">DELETED</div>
          <div *ngIf="worker" class="mb-2">
            <dl class="sideways-dl">
              <div>
                <dt>Name</dt>
                <dd>{{worker.name}}</dd>
              </div>
              <div>
                <dt>Username</dt>
                <dd>{{worker.login}}</dd>
              </div>
              <div>
                <dt>Email</dt>
                <dd>{{worker.email}}</dd>
              </div>
              <div>
                <dt>Phone</dt>
                <dd>{{worker.phoneNumber}}</dd>
              </div>
              <div>
                <dt>Activated</dt>
                <span *ngIf="worker.activated">&nbsp;<i class="fas fa-check-circle success"></i></span>
                <span *ngIf="!worker.activated">&nbsp;<i class="fas fa-times-circle danger"></i></span>
              </div>
              <div>
                <dt>Company</dt>
                <dd *ngIf="isAdmin || isSiteOwner || isSiteDelegate || isAuthorisingOfficer">
                  <a [routerLink]="['/', routeRole, 'contractors', worker.contractor.id, 'workers']">
                    {{worker.contractor.name}}
                  </a>
                </dd>
                <dd *ngIf="!isAdmin && !isSiteOwner && !isSiteDelegate && !isAuthorisingOfficer">{{worker.contractor.name}}</dd>
              </div>
              <div *ngIf="isAdmin">
                <button type="button" class="btn btn-primary btn-link" (click)="editUser()">edit</button>
                <button type="button" class="btn btn-primary btn-link" (click)="changePassword()">change password</button>
                <button type="button" class="btn btn-primary btn-link" (click)="switchContractor()">change contractor</button>
                <button type="button" class="btn btn-danger btn-link" *ngIf="!worker.deleted" (click)="deleteUser()">soft delete</button>
              </div>
              <div *ngIf="isSiteOwner || isSiteDelegate">
                <button type="button" class="btn btn-primary btn-link" (click)="editUser()">edit</button>
              </div>
            </dl>

            <div class="sl-accordion">
              <div class="widescreen-inline">
                <sl-accordion-section *ngIf="(isPowerStationOwnerView || isPowerStationManagerView) && workerIsApprovedOnSite !== undefined" title='Added to Site'>
                  <div>
                    <span *ngIf="workerIsApprovedOnSite">&nbsp;<i class="fas fa-check-circle success"></i></span>
                    <span *ngIf="!workerIsApprovedOnSite">&nbsp;<i class="fas fa-times-circle danger"></i></span>
                  </div>
                  <!-- TODO POWERSTATION -->
                  <!-- <div class="button-link-wrapper">
                    <button *ngIf="workerIsApprovedOnSite" type="button" class="btn btn-primary btn-link" (click)="addToSite(false)">remove from site</button>
                    <button *ngIf="!workerIsApprovedOnSite" type="button" class="btn btn-primary btn-link" (click)="addToSite(true)">add to site</button>
                  </div> -->
                </sl-accordion-section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Edit Worker User" [(visible)]="editUserModal" modal="true" [baseZIndex]="1000000">
  <form [formGroup]="editUserForm" (ngSubmit)="onEditUserFormSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name <span class="required-star">*</span></label>
          <input type="text" class="form-control" formControlName="firstName" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name <span class="required-star">*</span></label>
          <input type="text" class="form-control" formControlName="lastName" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email <span class="required-star">*</span></label>
          <input type="email" class="form-control" formControlName="email" placeholder="" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Phone Number <span class="required-star">*</span></label>
          <input type="text" class="form-control" formControlName="phoneNumber" placeholder="" />
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="editUserModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onEditUserFormSubmit()" [disabled]="!editUserForm.valid" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </p-footer>
</p-dialog>

<!-- change contractor Dialogue -->
<p-dialog header="Change Contractor For Worker" [(visible)]="showSwitchContractorModal" modal="true" [baseZIndex]="1000000">
  <div>
    <div class="form-group">
      <label>Companies</label><br />
      <p-dropdown
        [disableControl]="!contractorsOptionsList.length"
        class="form-control"
        [(ngModel)]="selectedContractor"
        placeholder='loading.....'
        [ngModelOptions]="{standalone: true}"
        [options]="contractorsOptionsList"
        filter="true">
      </p-dropdown>
    </div>
  </div>
  <p-footer>
    <button type="button" (click)="showSwitchContractorModal = false" class="my-2 btn btn-round btn-sm btn-default float-left">Cancel</button>
    <button type="button" (click)="onSwitchContractorSubmit()" [disabled]="saveInProgress || !selectedContractor" class="my-2 btn btn-round btn-sm btn-success">Change Contractor</button>
  </p-footer>
</p-dialog>
